import { render, staticRenderFns } from "./SProd.vue?vue&type=template&id=165d2cda"
import script from "./SProd.vue?vue&type=script&lang=js"
export * from "./SProd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports